import { render, staticRenderFns } from "./BoothAdvertisingTwo.vue?vue&type=template&id=47dcdb76&scoped=true"
import script from "./BoothAdvertisingTwo.vue?vue&type=script&lang=js"
export * from "./BoothAdvertisingTwo.vue?vue&type=script&lang=js"
import style0 from "./BoothAdvertisingTwo.vue?vue&type=style&index=0&id=47dcdb76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dcdb76",
  null
  
)

export default component.exports